"use client";

import React, { useState, useLayoutEffect, useRef } from "react";
import { createPortal } from "react-dom";
import TextareaAutosize from "react-textarea-autosize";
import styled from "styled-components";
import Text from "../../Text";
import { BulkMultiSelectTrigger } from "./BulkCellContent";

const BulkFloatingTextarea = styled(TextareaAutosize)`
  background: white;
  border-radius: 4px;
  box-shadow:
    0 2px 8px rgba(0, 0, 0, 0.08),
    0 8px 24px rgba(0, 0, 0, 0.12);
  padding: 12px 16px;
  font-size: 13px;
  line-height: 1.6;
  outline: none;
  resize: none;
  z-index: 9999;
  font-family: inherit;
  color: #111;
  min-width: 300px;
`;

type Props = {
  onCommit: (value: string) => void;
};

const BulkLongtextCell: React.FC<Props> = ({ onCommit }) => {
  const [textValue, setTextValue] = useState("");
  const [open, setOpen] = useState(false);
  const triggerRef = useRef<HTMLButtonElement>(null);
  const [rect, setRect] = useState<DOMRect | null>(null);

  useLayoutEffect(() => {
    if (open && triggerRef.current) {
      setRect(triggerRef.current.getBoundingClientRect());
    } else {
      setRect(null);
    }
  }, [open]);

  return (
    <>
      <BulkMultiSelectTrigger ref={triggerRef} type="button" onClick={() => setOpen(true)}>
        {textValue ? (
          <Text
            style={{
              fontSize: "inherit",
              color: "#111",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}>
            {textValue}
          </Text>
        ) : (
          <Text style={{ fontSize: "inherit", color: "#aaa", fontStyle: "italic" }}>
            Bulk edit…
          </Text>
        )}
      </BulkMultiSelectTrigger>
      {open &&
        rect &&
        createPortal(
          <BulkFloatingTextarea
            autoFocus
            style={{
              position: "fixed",
              top: rect.top - 16,
              left: rect.left - 16,
              width: rect.width + 116,
            }}
            defaultValue={textValue}
            onBlur={e => {
              const v = e.currentTarget.value;
              setTextValue(v);
              if (v) onCommit(v);
              setOpen(false);
            }}
            onKeyDown={(e: React.KeyboardEvent<HTMLTextAreaElement>) => {
              if (e.key === "Escape") {
                setOpen(false);
                return;
              }
              if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) {
                const v = (e.target as HTMLTextAreaElement).value;
                setTextValue(v);
                if (v) onCommit(v);
                setOpen(false);
              }
            }}
            minRows={4}
          />,
          document.body
        )}
    </>
  );
};

export default BulkLongtextCell;
